import { axiosClient } from '@services/clients'
import { serializeListParams } from './serializeListParams'

export async function getBonuses(filters) {
  const { data } = await axiosClient(`/bonuses?${serializeListParams(filters)}`)
  return data
}

export async function publishBonus(bonusId) {
  const { data } = await axiosClient.post(`/bonus/${bonusId}/publish`, {})
  return data
}

export async function deleteBonus(bonusId) {
  const { data } = await axiosClient.delete(`/bonus/${bonusId}`)
  return data
}

export async function getBonus(bonusId) {
  const { data } = await axiosClient(`/bonus/${bonusId}`)

  return data
}

export async function newBonus(dataB) {
  const {
    data: { result },
  } = await axiosClient.post('/bonus', dataB)
  return result
}

export async function editBonus(bonusId, data) {
  const {
    data: { result },
  } = await axiosClient.patch(`/bonus/${bonusId}`, data)
  return result
}
